import styled from 'styled-components';

import { RefetchInterval } from '../../sportsbook-constants';
import { useTypedTranslations } from '../../../../translation/use-translations';
import DesktopMenuTextKeys from './sportsbook-desktop-menu-text-keys';
import useQueryFeaturedLeagues from '~/components/sportsbook/lobby/queries/leagues/use-query-featured-leagues';
import useQueryExploreQuickLinks from '~/components/sportsbook/lobby/queries/quick-links/use-query-quick-links';
import SportsbookDesktopMenuSports from './components/sportsbook-desktop-menu-sports';
import SportsbookDesktopMenuQuickLinks from './components/sportsbook-desktop-menu-quick-links';

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	height: fit-content;
	flex: 1;
	min-width: 250px;
	max-width: 330px;
	gap: 20px;
`;

export const SkeletonDesktopMenu = styled.div`
	height: 570px;
`;

const SportsbookDesktopMenu = () => {
	const {
		data: quickLinks,
		isPending: isPendingQuickLinks,
		isError: isErrorQuickLinks
	} = useQueryExploreQuickLinks({
		refetchInterval: RefetchInterval.LONG
	});
	const { data: leagues, isPending: isPendingLeagues } = useQueryFeaturedLeagues({
		refetchInterval: RefetchInterval.LONG
	});
	// Preload translations
	const { isLoadingTranslations } = useTypedTranslations(DesktopMenuTextKeys);

	if (isPendingQuickLinks || isPendingLeagues || isLoadingTranslations) {
		return (
			<Wrapper>
				<SkeletonDesktopMenu />
			</Wrapper>
		);
	}

	const hasNoQuickLinks = isErrorQuickLinks || quickLinks.length === 0;

	const hasNoLeagues = leagues?.length === 0;

	if (hasNoQuickLinks && hasNoLeagues) {
		return null;
	}

	return (
		<Wrapper>
			<SportsbookDesktopMenuQuickLinks />
			<SportsbookDesktopMenuSports />
		</Wrapper>
	);
};

export default SportsbookDesktopMenu;
